export default "__VITE_ASSET__DUdtRT_2__"